module.exports = __webpack_public_path__ + "img/partner2.00f27f0a.png";